<template>
  <v-main>
    <v-container fluid>
      <v-col cols="12" class="py-0">
        <v-card elevation="2">
          <v-card-title class="mt-4">
            <v-col xl="1" lg="1" md="2" sm="4" cols="4">
              <v-img
                class="rounded-pill"
                width="70"
                height="70"
                :src="mediaUrl + profile.companies[0].logo_path"
              />
            </v-col>
            <v-col>
              <span :class="$vuetify.breakpoint.smAndDown ? 'text-body-2' :  ''">{{ profile.name }}</span> <br />
              <span :class="$vuetify.breakpoint.smAndDown ? 'text-caption' :  'text-body-2'"
                >{{ profile.companies[0].name }} role : {{ roleName }}</span
              >
            </v-col>
            <vs-button
              border
              color="#b0b0b0"
              @click="EditFormdialog = true"
              class="px-2 py-0 profile-edit-button"
            >
              Edit <v-icon size="15">mdi-square-edit-outline</v-icon>
            </vs-button>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <v-row>
              <v-col cols="12">
                <span class="text-h6"> Profile Information</span>
              </v-col>
              <v-col xl="6" lg="6" md="6" sm="12" cols="12">
                <span class="font-weight-bold text-body-1">Name</span> <br />
                <span class="text-body-2">{{ profile.name }}</span>
              </v-col>
              <v-col xl="6" lg="6" md="6" sm="12" cols="12">
                <span class="font-weight-bold text-body-1">Email</span> <br />
                <span class="text-body-2">{{ profile.email }}</span>
              </v-col>
              <v-col xl="6" lg="6" md="6" sm="12" cols="12">
                <span class="font-weight-bold text-body-1">Phone</span> <br />
                <span class="text-body-2">{{ profile.phone }}</span>
              </v-col>
              <v-col xl="6" lg="6" md="6" sm="12" cols="12">
                <span class="font-weight-bold text-body-1">Role</span> <br />
                <span class="text-body-2">{{ profile.roles[0].name }}</span>
              </v-col>
              <v-col xl="6" lg="6" md="6" sm="12" cols="12">
                <vs-button color="#6c5dd4" @click="PasswordResetDialog = true">
                  Change Password
                </vs-button>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      <vs-dialog v-model="EditFormdialog" :loading="isLoading">
        <v-row>
          <v-col cols="12">
            <span class="text-h6"> Edit Admin Details </span>
          </v-col>
          <v-col xl="6" lg="6" md="6" sm="12" cols="12" class="px-1">
            <label for="" class="text-caption">Name * </label>
            <vs-input
              primary
              v-model="profile.name"
              placeholder="Enter a name"
              icon-after
              block
            >
              <template #icon>
                <i class="mdi mdi-account"></i>
              </template>

              <template #message-danger>
                {{ errors && errors.name ? errors.name : "" }}
              </template>
            </vs-input>
          </v-col>
          <v-col xl="6" lg="6" md="6" sm="12" cols="12" class="px-1">
            <label for="" class="text-caption">Email * </label>
            <vs-input
              primary
              v-model="profile.email"
              placeholder="Enter a email"
              icon-after
              block
            >
              <template #icon>
                <i class="mdi mdi-email"></i>
              </template>

              <template #message-danger>
                {{ errors && errors.emai ? errors.email : "" }}
              </template>
            </vs-input>
          </v-col>
          <v-col xl="6" lg="6" md="6" sm="12" cols="12" class="px-1">
            <label for="" class="text-caption">Phone * </label>
            <vs-input
              primary
              v-model="profile.phone"
              placeholder="Enter a phone number"
              icon-after
              block
            >
              <template #icon>
                <i class="mdi mdi-phone"></i>
              </template>

              <template #message-danger>
                {{ errors && errors.phone ? errors.phone : "" }}
              </template>
            </vs-input>
          </v-col>
          <v-col cols="12">
            <vs-button
              style="float: right"
              :loading="isLoading"
              :disabled="isLoading"
              color="#6c5dd4"
              @click="update"
            >
              Update
            </vs-button>
          </v-col>
        </v-row>
      </vs-dialog>
      <vs-dialog v-model="PasswordResetDialog" :loading="isLoading">
        <v-row>
          <v-col cols="12">
            <span class="text-h6"> Reset Password </span>
          </v-col>
          <v-col xl="6" lg="6" md="6" sm="12" cols="12" class="px-1">
            <label for="" class="text-caption">Email </label>
            <vs-input
              primary
              v-model="profile.email"
              icon-after
              disabled
              block
            >
              <template #icon>
                <i class="mdi mdi-lock"></i>
              </template>
            </vs-input>
          </v-col>
          <v-col xl="6" lg="6" md="6" sm="12" cols="12" class="px-1">
            <label for="" class="text-caption">New Password * </label>
            <vs-input
              primary
              v-model="PasswordForm.password"
              placeholder="Enter a new password"
              icon-after
              block
            >
              <template #icon>
                <i class="mdi mdi-lock"></i>
              </template>
            </vs-input>
          </v-col>
          <v-col xl="6" lg="6" md="6" sm="12" cols="12" class="px-1">
            <label for="" class="text-caption">Re-Enter Password * </label>
            <vs-input
              primary
              v-model="PasswordForm.password_confirmation"
              placeholder="Re-Enter a new password"
              icon-after
              block
            >
              <template #icon>
                <i class="mdi mdi-lock"></i>
              </template>
            </vs-input>
          </v-col>
          <v-col cols="12">
            <vs-button
              style="float: right"
              color="#6c5dd4"
              @click="change_password"
            >
              Change
            </vs-button>
          </v-col>
        </v-row>
      </vs-dialog>
    </v-container>
  </v-main>
</template>

<script type="text/javascript">
import axios from "axios";

export default {
  name: "user",
  data() {
    return {
      profile: {
        role_id: "",
        active: "",
      },
      PasswordForm:{
        password: "",
        password_confirmation: "",
      },
      roleId: "",
      isLoading: false,
      EditFormdialog: false,
      PasswordResetDialog: false,
    };
  },
  mounted() {
    this.getData();
    this.roleId = this.user.roles[0].id;
  },
  methods: {
    async getData() {
      this.isLoading = true;
      let profile = await axios.get(`/users/${this.$route.params.userId}`);
      this.profile = profile.data.data;
      this.count = profile.data.count;
      this.isLoading = false;
    },
    async update() {
      try {
        this.isLoading = true;
        await axios.patch(`/users/${this.$route.params.userId}`, this.profile);
        this.isLoading = false;
        this.EditFormdialog = false;
        this.getData();
      } catch (e) {
        console.log(e);
        this.isLoading = false;
      }
    },
    async change_password() {
      try {
        this.isLoading = true;
        this.PasswordForm.email = this.profile.email;
        await axios.post(`/reset_password`, this.PasswordForm);
        this.$vs.notification({
            color : '#6c5dd4',
             position: 'top-center',
            title: 'Password Change Successfully',
            text: `your new password set successfully you can now login through your new password
            `
          })
        this.isLoading = false;
        this.PasswordResetDialog = false;
        this.getData();
      } catch (e) {
        console.log(e);
        this.isLoading = false;
      }
    },
  },
};
</script>
<style>
.profile-edit-button .vs-button__content {
  padding: 0px !important;
}
</style>
